import React from 'react';
import RouteError from 'components/errors/routeError';

export default function errorHandler(Component) {
    const originalRender = Component.prototype.render;

    Component.prototype.render = function render() {
        try {
            return originalRender.apply(this, arguments);
        } catch (err) {
            /* eslint no-console:0 */
            console.log('Failed on render with', err);

            if (Raven && typeof Raven.captureException === 'function') {
                Raven.captureException(err);
            }

            return <RouteError error={err} component={this} />;
        }
    };

    return Component;
}



// WEBPACK FOOTER //
// ./app/assets/javascripts/utils/errorHandler.jsx